// extracted by mini-css-extract-plugin
module.exports = {"comments":"PhotoComment_comments__mvcGG","single":"PhotoComment_single__2OkYG"};